// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nav-item.nav-item-dropdown {\n  padding: 0 12px !important;\n}\n", ""]);
// Exports
module.exports = exports;
